export default __webpack_public_path__ + "static/media/cp_geo_fo.e6f46df7.svg";